import { render, staticRenderFns } from "./process-home.vue?vue&type=template&id=1e8ae3e2"
import script from "./process-home.vue?vue&type=script&lang=js"
export * from "./process-home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports